export default __webpack_public_path__ + "static/media/minus.a66e7063.svg";